<script setup lang="ts">
import { NxtFormSection } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import ThemeFormSection from '@/apps/admin/components/forms/settings/ThemeFormSection.vue';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
</script>

<template>
   <div>
      <NxtFormSection :title="$t('job-board.settings.theme.theme')">
         <ThemeFormSection v-model="jobBoard" />
      </NxtFormSection>
   </div>
</template>
